export default __webpack_public_path__ + "static/media/skribbl.4d1371e0.gif";